import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import ServiceCard from './ServiceCard';

// Import icons from Material-UI
import MemoryIcon from '@mui/icons-material/Memory';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import CodeIcon from '@mui/icons-material/Code';
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';
import SchoolIcon from '@mui/icons-material/School';
import LanguageIcon from '@mui/icons-material/Language';
import InstallDesktopIcon from '@mui/icons-material/InstallDesktop';
import CottageIcon from '@mui/icons-material/Cottage';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import LaptopIcon from '@mui/icons-material/Laptop';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import BuildIcon from '@mui/icons-material/Build';
import ComputerIcon from '@mui/icons-material/Computer';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import EngineeringIcon from '@mui/icons-material/Engineering';
import HandymanIcon from '@mui/icons-material/Handyman';
import SettingsIcon from '@mui/icons-material/Settings';
import SecurityIcon from '@mui/icons-material/Security';
// or
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import VerifiedIcon from '@mui/icons-material/Verified';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
// and so on...
// or for a slightly more specific look:
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
const Services = () => {
  const services = [
    {
      title: "Chip Level Service",
      icon: <MemoryIcon fontSize="large" />,
      items: [
        "Laptop & Desktop Motherboard",
        "Complete Checkup",
        "BIOS Programming & Update",
        "Recovery of Dead Hard Disk & Display",
        "Firmware Update"
      ]
    },
    {
      title: "Software Troubleshooting",
      icon: <TroubleshootIcon fontSize="large" />,
      items: [
        "OS Issues",
        "Software Crashes",
        "Virus Removal",
        "Driver Updates",
        "Data Recovery"
      ]
    },
    {
      title: "Software Development",
      icon: <CodeIcon fontSize="large" />,
      items: [
        "Inventory and Order Management",
        "Billing & Invoicing Software",
        "Appointment Scheduling",
        "Expense Tracker"
      ]
    },
    {
      title: "PC Build",
      icon: <ImportantDevicesIcon fontSize="large" />,
      items: [
        "Intel Processor PC Build",
        "AMD Processor PC Build"
      ]
    },
    {
      title: "Training & Internship",
      icon: <SchoolIcon fontSize="large" />,
      items: [
        "Corporate IT Training",
        "Student Internships",
        "Workshops on AI, ML, Cybersecurity"
      ]
    },
    {
      title: "Web & Digital Services",
      icon: <LanguageIcon fontSize="large" />,
      items: [
        "Digital Marketing",
        "Shopping Websites",
        "Social Media Platforms",
        "Blogs",
        "Business Websites",
        "IT Consulting",
        "Remote IT Support"
      ]
    },
    {
      title: "Software Installation",
      icon: <InstallDesktopIcon fontSize="large" />,
      items: [
        "Windows OS & Linux",
        "Microsoft Office",
        "Engineering Software",
        "Editing Software"
      ]
    },
    {
      title: "Security",
      icon: <VerifiedUserIcon fontSize="large" />,
      items: [
        "Antivirus",
        "CCTV Setup",
        "Biometric & Access Control"
      ]
    },
    {
      title: "Accessories",
      icon: <DevicesOtherIcon fontSize="large" />,
      items: [
        "Laptop & Desktop",
        "Keyboard & Mouse",
        "Monitor",
        "Motherboard",
        "SSD, RAM, Hard Disk",
        "SMPS & Cabinets",
        "Laptop Battery",
        "Laptop Hinches & Screens"
      ]
    },
    {
      title: "Brand New Laptop",
      icon: <LaptopIcon  fontSize="large" />,
      items: [
        "DELL",
        "LENOVO",
        "ACER",
        "HP",
        "ASUS"
      ]
    },
    {
      title: "Corporate IT Support",
      icon: <CorporateFareIcon   fontSize="large" />,
      items: [
        "TATA",
        "Max Life Insurance",
        "Kotak Mahindra Bank"
      ]
    },
    {
      title: "Hardware Upgradation",
      icon: <SettingsIcon   fontSize="large" />,
      items: [
        "RAM Upgrade",
        "SSD Installation",
        "Graphics Card Upgrade",
        "Processor Upgrade",
        "Power Supply Upgrade",
        "Motherboard Replacement",
        "Cooling System Enhancement",
        "Storage Expansion",
        "Network Card Installation",
        "BIOS Update"
      ]
    }
  ];

  return (
    <section id="service-section" style={{ padding: '100px 20px' }}>
    <Box component="section" id="services" sx={{ 
      py: 8,
      backgroundColor: 'background.default'
    }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={8}>
          <Typography variant="h4" component="h2" gutterBottom 
          sx={{ 
            fontWeight: 'bold',
            color: 'primary.main'
          }}>
            Our Services
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Comprehensive Solutions for All Your Tech Needs
          </Typography>
        </Box>
        
        <Grid 
          container 
          spacing={4} 
          justifyContent="center"
        >
          {services.map((service, index) => (
            <Grid item key={index} xs={12} sm={6} md={4} sx={{ display: 'flex', justifyContent: 'center' }}>
              <ServiceCard 
                icon={service.icon}
                title={service.title} 
                items={service.items} 
                index={index} 
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
    </section>);
};

export default Services;